import React from "react";
import { Modal, Button } from "react-bootstrap";
import Success from "../../assets/images/success.svg";
import CustomButton from "../CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";

const CourseCompleteSuccessModal = ({
  text,
  show,
  handleClose,
  handleContinue,
}) => {
  return (
    <Modal className="success-modal" show={show} onHide={handleClose} centered>
      <Modal.Header className="align-items-center pb-10">
        <h4 className="fw-bold mb-0">Congratulations!</h4>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={handleClose}
        />
      </Modal.Header>

      <Modal.Body className="text-center">
        <p className="text-muted ah-text-md">
          <pre
            style={{
              whiteSpace: "pre-wrap",
              fontFamily: "inherit",
              fontSize: "inherit",
              color: "inherit",
            }}
          >
            {text}
          </pre>
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button
          onClick={handleContinue}
          classes={"btn btn-primary w-100 mb-10"}
          type={"button"}
        >
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CourseCompleteSuccessModal;
